.container {
  line-height: 2.4rem;
  color: var(--color-grayscale-light-slate);

  a {
    color: white;
    text-decoration: underline;
  }
}
